import { Route } from 'react-router-dom';
import { RequireCustomerAdmin } from '../../components/RequireCustomerAdmin.js';
import { WorkfrontCustomFormsMigrationPage } from './pages/WorkfrontCustomFormsMigrationPage.js';
import { WorkfrontObjectCatalogPage } from './pages/WorkfrontObjectCatalogPage.js';
import { WorkfrontReportingPage } from './pages/WorkfrontReportingPage.js';
import { WorkfrontResourceManagementPage } from './pages/WorkfrontResourceManagementPage.js';

/**
 * Workfront slice — four pages:
 *  - **Object catalog** (`/workfront`): read-only catalog of every
 *    Workfront object referenced by any Fusion scenario on the
 *    license. Sourced from `/v1/workfront/object-catalog`.
 *  - **Custom forms migration** (`/workfront/custom-forms-migration`):
 *    live Clone + Replace wizard backed by
 *    `/v1/workfront/custom-forms`. Drives the engine's per-license
 *    apiKey through to `attask/api/v21.0/CTGY|PGRP|PARAM/*`.
 *  - **Reporting** + **Resource management**: skeleton pages today.
 *    Light up once their respective aggregate queries land (separate
 *    slice — needs new engine endpoints, not just a Workfront proxy).
 */
export function workfrontRoutes(): JSX.Element {
  return (
    <>
      <Route path="/workfront" element={<WorkfrontObjectCatalogPage />} />
      <Route
        path="/workfront/custom-forms-migration"
        element={
          <RequireCustomerAdmin>
            <WorkfrontCustomFormsMigrationPage />
          </RequireCustomerAdmin>
        }
      />
      <Route path="/workfront/reporting" element={<WorkfrontReportingPage />} />
      <Route path="/workfront/resource-management" element={<WorkfrontResourceManagementPage />} />
    </>
  );
}
